import React from 'react'
import PropTypes from 'prop-types'
import Immutable from 'seamless-immutable'
import { Link, colors } from '@blocket/blocket-ui'
import staticFilesUrl from 'constants/staticFiles'

const styles = Immutable.from({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: colors.white100,
    flex: '1 1 auto',
    margin: '16px',
  },
  titleWrapper: {
    lineHeight: '1.27',
    textAlign: 'center',
    fontSize: '24px',
    fontColor: colors.black100,
    paddingTop: '20px',
    paddingBottom: '10px',
    fontFamily: "'BlocketSans-Medium', sans-serif",
  },
  messageWrapper: {
    lineHeight: '1.62',
    textAlign: 'center',
    color: colors.black100,
    fontSize: '16px',
    paddingBottom: '10px',
  },
  link: {
    color: colors.blue600,
  },
})

const image = 'needhelp'

const ServerErrorComponent = ({ baseUrl }) => (
  <div style={styles.container}>
    <style type="text/css">
      {`
          html {
            min-height: 100%;
          }
          body {
            display: flex;
            flex-direction: column;
          }
          #root {
            display: flex;
            flex: 1;
            flex-direction: column;
          }
        `}
    </style>
    <img
      style={{ maxWidth: '280px' }}
      aria-hidden
      alt=""
      src={`${staticFilesUrl}/assets/images/${image}.png`}
      srcSet={
        `${staticFilesUrl}/assets/images/${image}@2x.png 2x, ` +
        `${staticFilesUrl}/assets/images/${image}@3x.png 3x`
      }
    />
    <div style={styles.titleWrapper}>Ånej!</div>
    <div style={styles.messageWrapper}>Något blev fel. Försök igen.</div>
    <Link style={styles.link} to={baseUrl || '/'}>
      Tillbaka till startsidan
    </Link>
  </div>
)

ServerErrorComponent.propTypes = {
  baseUrl: PropTypes.string,
}

export default ServerErrorComponent
